import React, { useRef } from 'react';

import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';

import '@splidejs/react-splide/css';
import ASSETS from '../../../assets';

const CONFIG = [
  {
    img: ASSETS.usman_hanjra,
    name: 'Usman Hanjra',
    post: 'Advocate High Court',
    about: `I highly recommend Legal Avenue as an invaluable platform for accessing reliable legal advice quickly. This platform offers an efficient and direct way to connect with experienced lawyers, making legal assistance more accessible. It’s an essential tool for anyone seeking prompt and effective legal support.`,
  },
  {
    img: ASSETS.zeeshan_tariq,
    name: 'Zeeshan Tariq',
    post: 'Advocate High Court',
    about:
      'This online platform has revolutionized access to legal services, making it significantly easier for the public to connect with experienced legal professionals. Legal Avenue is an invaluable tool for anyone in need of legal guidance, I ensure that legal assistance is more accessible and efficient than ever.',
  },

  {
    img: ASSETS.shoaib,
    name: 'Sohaib Hamid',
    post: 'Advocate High Court',
    about: `Legal Avenue is an outstanding capability to streamline legal consultations and enhance accessibility. The platform provides straightforward access to skilled lawyers, ensuring that legal support is always available.`,
  },
  {
    img: ASSETS.rao_farhan,
    name: 'Rao Farhan',
    post: 'Advocate High Court',
    about: `This platform is a reliable and efficient solution for all your legal needs. Legal Avenue has made it significantly easier for the public to connect with experienced legal professionals, offering invaluable guidance and support. It’s a great tool for anyone seeking legal advice, simplifying access to legal services and ensuring a smooth, accessible experience.`,
  },
  {
    img: ASSETS.rana_suchar,
    name: 'Rana Suchar',
    post: 'LLB (Hons) University of London',
    about: `I highly recommend Legal Avenue as a user-friendly platform that makes legal assistance more approachable and accessible. This innovative platform has simplified the process of connecting with qualified legal professionals, making it easier for everyone to find the help they need. It’s an essential tool for anyone in need of legal support, ensuring that professional guidance is just a click away.`,
  },
  {
    img: ASSETS.hassan_samra,
    name: 'Hassan Samra',
    post: 'Advocate High Court',
    about: `I fully endorse Legal Avenue as an invaluable platform for accessing reliable legal advice quickly. Legal Avenue offers an efficient way to connect with experienced lawyers, making it easier for the general public to get the legal assistance they need.`,
  },
];

const Testimonials = () => {
  const splide = useRef(null);

  const goToPrevSlide = () => {
    if (splide.current) {
      // @ts-ignore
      splide.current.splide.go('<');
    }
  };

  const goToNextSlide = () => {
    if (splide.current) {
      // @ts-ignore
      splide.current.splide.go('>');
    }
  };

  return (
    <div className='md:mt-[120px] mt-12'>
      <p className='lg:text-[40px] lg:leading-[52px] text-3xl leading-[44px] text-l-primary font-bold max-w-[25ch]'>
        Hear What the Top Lawyers have to say
      </p>
      <div className='w-full bg-l-light-grey rounded-[24px] mt-10 relative'>
        <Splide
          hasTrack={false}
          ref={splide}
          options={{
            arrows: false,
            pagination: false,
            type: 'loop',
            autoplay: true,
          }}
        >
          <SplideTrack>
            {CONFIG.map((item, i) => (
              <SplideSlide key={i}>
                <div className='flex lg:flex-row flex-col  items-start 2xl:gap-8 gap-5 relative md:p-6 p-4'>
                  <img
                    src={ASSETS.quotes}
                    className='absolute top-[40px] right-[40px]'
                    alt=''
                  />
                  <img
                    src={item.img}
                    className='h-full lg:max-w-[474px] max-[1200px]:max-w-[400px] max-[1020px]:!max-w-[100vw] lg:inline-block hidden rounded-[24px]'
                    alt=''
                  />
                  <img
                    src={item.img}
                    className='w-full lg:hidden inline-block rounded-[24px]'
                    alt=''
                  />
                  <div className='md:mt-[32px] mt-5 md:pb-0 pb-12 '>
                    <div className='flex items-center gap-4'>
                      <div>
                        <p className='text-2xl text-l-primary font-semibold'>
                          {item.name}
                        </p>
                        <p className='text-base font-medium text-l-primary'>
                          {item.post}
                        </p>
                      </div>
                    </div>
                    <p className='lg:text-lg text-base text-l-primary mt-[32px] pr-10  '>
                      {item.about}
                    </p>
                  </div>
                </div>
              </SplideSlide>
            ))}
          </SplideTrack>
        </Splide>
        <div className='flex items-center gap-[6px] absolute right-10 bottom-6'>
          <button
            onClick={goToPrevSlide}
            className='h-12 w-[70px] bg-white grid place-items-center rounded-[100px]'
          >
            <img src={ASSETS.chevronRight} className='rotate-180' alt='' />
          </button>
          <button
            onClick={goToNextSlide}
            className='h-12 w-[70px] bg-white grid place-items-center rounded-[100px]'
          >
            <img src={ASSETS.chevronRight} alt='' />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
